var app = angular.module('tf.tradingPortal', [])

    .controller('tradingPortalCtrl', ['$scope', '$http', '$uibModal', '$uibModalInstance', '$timeout', 'terms', '$state', function tradingPortalController($scope, $http, $uibModal, $uibModalInstance, $timeout, terms, $state) {


        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.refreshPortfolios = function () {
            $http.get('/tradefloor/api/client/portfolios', {ignoreLoadingBar : true}).then(function(response) {
                var data = response.data;
                $scope.portfolios = data;
                $scope.currentPortfolio = $scope.portfolios[0];
            })
        };

        $scope.currentPortfolio = null;

        $scope.refreshPortfolios();

        $scope.selectPortfolio = function(portfolio) {
            $scope.currentPortfolio = portfolio;
        };

        $scope.goToStrategy = function() {
            $state.transitionTo('strategy');
            $uibModalInstance.dismiss('cancel');
        };

        $scope.goToPortfolio = function() {
            $state.go('portfolio', {portfolioId : $scope.currentPortfolio.portfolioId});
            $uibModalInstance.dismiss('cancel');
        };

        $scope.goToCharting = function() {
            $state.transitionTo('charting');
            $uibModalInstance.dismiss('cancel');
        };

        $scope.goToStockScreener = function() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/apps/stockScreener/stockScreener.tpl.html',
                controller: 'stockScreenerCtrl as stockScreenerCtrl',
                size: 'fs',
                windowClass: 'fsModalScreener',
                resolve: {
                    actionText : function() {
                        return 'View in Strategy Builder'
                    }
                }
            });
            modalInstance.result.then(function(underlying) {
                $state.go ("strategy", {underlying: underlying});
            });

            $uibModalInstance.close();
        };


        $scope.goToWizard = function() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/game/partials/introCourse/openBuilderWizard.tpl.html',
                controller: 'splashCtrl as splashCtrl',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                }
            });
            modalInstance.result.then(function () {

            });

            $uibModalInstance.close();
        }


        //$scope.refreshPortfolios = function () {
        //    $http.get('/tradefloor/api/client/portfolios', {ignoreLoadingBar : true}).then(function(response) {
        //        var data = response.data;
        //        $scope.portfolios = data;
        //        $scope.currentPortfolio = $scope.portfolios[0];
        //    }
        //}

    }]);





